angular.module('wbDashboard').controller('PlansDetailFeatureTaxpreferredaccountControllerAurea', ['$scope', 'NgTableParams', 'PlanService', 'User', 'Milestone', 'Message', function ($scope, NgTableParams, PlanService, User, Milestone, Message) {

    $scope.status = {
        hasIra: false,
        hasRoth: false,
        hasTrad: false,
        hasSep: false,
        hasRetirement: false,
        hasIraPending: false,
        hasAccountPending: false,
        hasIraActive: false,
        missingLimit: false,
    };
    $scope.pendingIra = null;
    $scope.currentYear = new Date().getFullYear();
    $scope.totals = {};

    $scope.$watch('feature', function(feature) {
        if (feature) {
            setEditTab();
        }
    });

    $scope.$watch('iraForecast', function(forecast) {
        if (forecast) {
            angular.extend($scope.totals, {
                accrued_tax_value: 0,
                total_tax_value: 0,
            });
            angular.forEach(forecast, function (account) {
                $scope.totals.accrued_tax_value += account.accrued_tax_value*1;
                $scope.totals.total_tax_value += account.total_tax_value*1;
            });
        }
    });

    $scope.$watch(function() { return User.getMilestoneByType('retirement'); }, function(retirement) {
        if (retirement) {
            $scope.retirement = retirement;
            $scope.status.hasRetirement = retirement.id;
            Milestone.available_accounts({msId:$scope.retirement.id}).then(function(accounts) {
                $scope.availableAccounts = accounts;
            });

            angular.extend($scope.totals, {
                value: 0,
                autos: 0,
                deposits: 0,
                limits: null,
                ytd: 0,
            });

            $scope.status.missingLimit = false;
            var tableAccounts = [];
            angular.forEach($scope.retirement.accounts, function(account) {
                if (account.type.includes("ira")) {

                    $scope.totals.ytd += account.metrics.current_year_contributions;

                    $scope.totals.value += account.metrics.value;
                    $scope.totals.autos += account.auto_deposit;
                    $scope.totals.deposits += account.metrics.total_credits;
                    if (account.annual_deposit_limit !== null) {
                        //want to stay null if none set
                        $scope.totals.limits += account.annual_deposit_limit*1;
                    } else if (account.annual_deposit_limit === null) {
                        $scope.status.missingLimit = true;
                    }

                    tableAccounts.push(account);

                }
            });

            $scope.accountTable = new NgTableParams({
                // initial sort order
                count: 15,
                sorting: {}
            }, {
                counts: [],
                dataset: tableAccounts
            });

        }
    });

    $scope.$watch(User.getOverview, function(overview) {
        if (overview) {
            $scope.status.hasAccountPending = !!overview.pending_account;

            angular.forEach(overview.account_overview, function(account) {
                if (account.type.includes('roth')) {
                    $scope.status.hasRoth = true;
                }
                if (account.type.includes('traditional')) {
                    $scope.status.hasTrad = true;
                }
                if (account.type.includes('sep')) {
                    $scope.status.hasSep = true;
                }

                if (account.type.includes('ira')) {
                    $scope.status.hasIra = true;
                    if (account.is_pending) {
                        $scope.status.hasIraPending = true;
                        $scope.pendingIra = account;
                    } else {
                        $scope.status.hasIraActive = true;
                    }
                }
            });

            setEditTab();
        }
    });

    $scope.goToEditStrategy = function() {
        if ($scope.status.missingLimit) {
            Message.add({
                key: 'missingLimit',
                text: 'Annual Deposit Limits must be set before editing your Funding Strategy',
                type: 'warning',
            });
            $scope.$state.go("base.plans.detail.plan.feature.detail.edit",{page:'annual-limit', returnTo:'strategy'});
        } else {
            $scope.$state.go("base.plans.detail.plan.feature.detail.edit",{page:'strategy'});
        }
    };

    function setEditTab() {
        if ($scope.feature.enabled && $scope.status.hasIra) {
            $scope.tabs.data.edit = {label: "Edit", value: "edit", callbacks: {}};
        } else {
            delete $scope.tabs.data.edit;
        }
    }

    $scope.localData.initialTab = function () {
        return "detail";
    };
    $scope.localData.hideDetail = function () {
        return false;
    };


    $scope.toggleFeature.onMessage = "We've sent an email with next steps.";
    $scope.toggleFeature.offMessage = false;

}]);
